// extracted by mini-css-extract-plugin
module.exports = {"Inputs":"ScaleSlider_Inputs__3xEUc","fadeIn":"ScaleSlider_fadeIn__2N_2R","modalFadeIn":"ScaleSlider_modalFadeIn__1bZtC","slideInFromRight":"ScaleSlider_slideInFromRight__3FdKD"};